import React from 'react';
const IconNavBlog = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M15 5C15 6.66 13.66 8 12 8C10.34 8 9 6.66 9 5C9 3.34 10.34 2 12 2C13.66 2 15 3.34 15 5ZM3 8C6.48 8 9.64 9.35 12 11.55C14.36 9.35 17.52 8 21 8V19C17.52 19 14.36 20.36 12 22.55C9.64 20.35 6.48 19 3 19V8Z" fill="#666666"/>
</svg>
);
};
export default IconNavBlog;